import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { useFormik } from 'formik';
import { IoMdClose } from "react-icons/io";
import SubmitField from "../Form/SubmitField";
import { EmailField } from "../Form";
import { emailValidation } from "../../utils/validation";
import * as yup from 'yup';
import { forgotPasswordServer } from "../../services/authService";


export default function ForgotPassword({forgot, setForgot }) {
  //   let [isOpen, setIsOpen] = useState(true)
  const [loader,setLoader]= useState(false);
  const [asForgotEmailIsSent,setAsForgotEmailIsSent] = useState(false)
  const [serverError,setServerError] = useState("")
  function closeModal() {
    setForgot(false);
    setTimeout(()=>{

      setAsForgotEmailIsSent(false)
    },500)

  }
  const formik = useFormik({
    initialValues: {
      email: "",
     
    },
    validationSchema:yup.object({
             email:emailValidation,
          
    }),
    onSubmit: async (values) => {
        setLoader(true)
         const result = await forgotPasswordServer(values)
      
          setAsForgotEmailIsSent(true)
          setLoader(false);
          setServerError(`Please check your email (${values.email}) for instructions on resetting your password. Thank you!`)
       
       
        
        

    },
  });
  return (
    <>
      <Transition appear show={forgot} as={Fragment}>
        <Dialog as="div" className="relative z-[4057] " onClose={()=>{}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25 before:absolute before:w-full before:h-full before:backdrop-blur-sm		" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full  max-w-2xl transform overflow-hidden rounded-2xl bg-white p-2 text-left align-middle shadow-xl transition-all">
                  <div className="py-3 ">
                    <IoMdClose
                      className="text-3xl cursor-pointer"
                      onClick={closeModal}
                    />
                  </div>
                  {!asForgotEmailIsSent ?
                  <div className="mt-2 border-2 border-beta p-2 rounded">
                    <h1 className="h2 text-center">Forgot Password</h1>
                   
                    <form onSubmit={formik.handleSubmit} className="px-5 md:px-10">
                
                      <EmailField
                        label="Email"
                        name="email"
                        placeholder="Email"
                        formik={formik}
                       
                      />
                     
                         
                      <div className=" py-2">
                        <SubmitField label="Submit" loader={loader}/>
                     
                      </div>
                    </form>
                  </div>
                  : 
                
                  <div className="mt-2 p-4 rounded py-1 relative bottom-5">
                  <p className="h2 text-center">{serverError}</p>
                 
                  
                </div>
}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
